import ToggleButtonGroup, {
  ToggleOption,
} from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';

export type RawMaterialCategoryActiveFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface RawMaterialCategoryFiltersProps {
  search: string;
  activeFilter: RawMaterialCategoryActiveFilter;
  onSearchChange: (value: string) => void;
  onActiveChange: (value: RawMaterialCategoryActiveFilter) => void;
}

const activeOptions: ToggleOption<RawMaterialCategoryActiveFilter>[] = [
  { value: 'ALL', label: 'Todas' },
  { value: 'ACTIVE', label: 'Activas' },
  { value: 'INACTIVE', label: 'Inactivas' },
];

const RawMaterialCategoryFilters = ({
  search,
  activeFilter,
  onSearchChange,
  onActiveChange,
}: RawMaterialCategoryFiltersProps) => {
  return (
    <div className="flex flex-col gap-4 border-b border-stroke px-5 py-4 dark:border-strokedark lg:flex-row lg:items-center lg:justify-between">
      <div className="w-full lg:max-w-md">
        <SearchInputField
          name="rawMaterialCategorySearch"
          value={search}
          placeholder="Buscar categoría..."
          withMargin={false}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <ToggleButtonGroup
        value={activeFilter}
        options={activeOptions}
        onChange={onActiveChange}
      />
    </div>
  );
};

export default RawMaterialCategoryFilters;
